import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '../../../contexts/ThemeContext';

const AuthLogo = () => {
  const { currentTheme, isDarkMode } = useTheme();
  
  // Use the blue color from button backgrounds
  const textColor = isDarkMode ? "#60A5FA" : "#1976d2";
  const shadowColor = isDarkMode ? "rgba(129, 140, 248, 0.3)" : "rgba(99, 102, 241, 0.3)";
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 4,
      }}
    >
      {/* Stylized "F" logo */}
    
      
      {/* Company name */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            fontSize: "24px",
            color: textColor,
            textTransform: "uppercase",
          }}
        >
          Vantage
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "300",
            fontSize: "24px",
            color: textColor,
            ml: 0.5,
            textTransform: "uppercase",
          }}
        >
          Alpha
        </Typography>
      </Box>
    </Box>
  );
};

export default AuthLogo; 